import React from "react";
import {Grid, Button, Paper, IconButton} from "@material-ui/core";
import style from "./style";
import TimeSlot from "../../components/TimeSlotDrawer";
import DinerButton from '../../components/DinerButton';
import { Form, Formik } from "formik";
import Fab from "@material-ui/core/Fab/Fab";
import Typography from "@material-ui/core/es/Typography/Typography";
import * as moment from "moment";
import {primaryColor, textGrey} from "../../config/theme";
import ConfirmationDialog from '../../components/Dialog/ConfirmationDialog'

import Edit from "@material-ui/icons/EditOutlined";
import Delete from "@material-ui/icons/DeleteOutlined";

import {NotificationManager} from "react-notifications";
import {checkStartEnd} from "../../utils/common-methods";
class Schedule extends React.Component {
  componentDidMount() {
    window.onload = function() {
      window.scrollTo(0,0);
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      openDrawer: false,
      confirmationDialog: false,
      daysToSelect: [
        {
          name: "S",
          value: "SUNDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "M",
          value: "MONDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "T",
          value: "TUESDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "W",
          value: "WEDNESDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "T",
          value: "THURSDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "F",
          value: "FRIDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "S",
          value: "SATURDAY",
          selected: false,
          slots: [],
          default: false
        }
      ],
      selectDays: [
        {
          name: "S",
          value: "SUNDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "M",
          value: "MONDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "T",
          value: "TUESDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "W",
          value: "WEDNESDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "T",
          value: "THURSDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "F",
          value: "FRIDAY",
          selected: false,
          slots: [],
          default: false
        },
        {
          name: "S",
          value: "SATURDAY",
          selected: false,
          slots: [],
          default: false
        }
      ],
      formData: [],
      dayToShow: null,
      currentSlots: false,
      showFurtherMessage: false
    };
  }

  toggelTimeSlotDrawer = () => {
    this.setState({ confirmationDialog: true });
   // this.setState({ openDrawer: !this.state.openDrawer });
  };
  selectDay = day => {
    let days = this.state.daysToSelect;
/*
    days[index].selected = !days[index].selected;
    days[index].default = !days[index].selected;

    const slots = this.props.schedules;*/
    if (day.selected) {
      const index = days.findIndex(item => item.name === day.name);
      if (index > -1) {
        days = days.map(sDay => {
          if (sDay.name !== day.name) {
            sDay.selected = false;
          }

          return sDay;
        });
      }
    }

    const currentSlots = day;

    this.setState({ daysToSelect: days, currentSlots, dayToShow: day.name });
  };

  handelCreate = formData => {
    const data = this.state.formData;
    const daysToSelect = this.state.daysToSelect;
    const { selectedDays } = formData;

    const newSlot = {
      start: moment(`${formData.fromTime} ${formData.from}`, 'HH:mm').format('HH:mm'),
      from: formData.from,
      end: moment(`${formData.toTime} ${formData.to}`, 'HH:mm').format('HH:mm'),
      to: formData.to
    };

    const daysMaped = daysToSelect.map((day, i) => {
      if (
        !!selectedDays &&
        !!selectedDays.length &&
        day.value == selectedDays[selectedDays.indexOf(day.value)]
      ) {
        day.slots.push(newSlot);
        day.selected = true;
      }
      return day;
    });

    if (!!formData.selectedDays && !!formData.selectedDays.length && formData.selectedDays.length > 0) {
      data.push(formData);
    }

    const upData = [];

    data.forEach(d => {
      upData.forEach(upD => {
        if (upD.start !== d.start && upD.end !== d.end) {
          upData.push(d);
        }
      })
    });

    this.setState(
      { formData: upData, daysToSelect: daysMaped, openDrawer: false, selectDays: [
          {
            name: "S",
            value: "SUNDAY",
            selected: false,
            slots: [],
            default: false
          },
          {
            name: "M",
            value: "MONDAY",
            selected: false,
            slots: [],
            default: false
          },
          {
            name: "T",
            value: "TUESDAY",
            selected: false,
            slots: [],
            default: false
          },
          {
            name: "W",
            value: "WEDNESDAY",
            selected: false,
            slots: [],
            default: false
          },
          {
            name: "T",
            value: "THURSDAY",
            selected: false,
            slots: [],
            default: false
          },
          {
            name: "F",
            value: "FRIDAY",
            selected: false,
            slots: [],
            default: false
          },
          {
            name: "S",
            value: "SATURDAY",
            selected: false,
            slots: [],
            default: false
          }
        ] },
      () => {
        this.props.onSubmit(this.state.daysToSelect)
      }
    );
  };

  updateWeekSlot = slot => {

    const {start, end} = slot;
    let to = "PM";
    let from = "AM";
    let fromTime = "";
    let toTime = "";

    if (parseInt(start.split(":")[0]) > 12) {
      from = "PM";
      let hour = parseInt(start.split(":")[0]) - 12;
      let mins = start.split(":")[1];
      fromTime = hour <= 9 ? "0" + hour + ":" + mins : hour + ":" + mins;
    } else {
      from = "AM";
      fromTime = start;
    }

    if (parseInt(end.split(":")[0]) > 12) {
      to = "PM";
      let hour = parseInt(end.split(":")[0]) - 12;
      let mins = end.split(":")[1];
      toTime = hour <= 9 ? "0" + hour + ":" + mins : hour + ":" + mins;
    } else {
      to = "AM";
      toTime = end;
    }

    this.setState({
      weekSlotToUpdate: {from, fromTime, to, toTime, start, end},
      updateSlotWeek: true
    });
  };

  deleteWeekSchedule = slot => {

    const {deleteWeeklySchedule, userId: chefId, weekSchedules} = this.props;
    const {
      selectedDay: {value}
    } = this.state;

    const {start, end} = slot;
    deleteWeeklySchedule({
      variables: {chefId, day: value, slot: {start, end}}
    })
        .then(res => {
          weekSchedules.refetch();
        })
        .catch(err => {
          let errorObj = JSON.parse(JSON.stringify(err));
          console.log(errorObj);
          if (errorObj.graphQLErrors) {
            errorObj.graphQLErrors.map(error => {
              NotificationManager.error(error.message, "Schedule");
            });
          }

        });
  };

  render() {
    const slots = this.props.schedules;

    let showCreateButton = true;

    if (slots.length > 0) {
      showCreateButton = false;
    }

    let { currentSlots, daysToSelect, dayToShow, formData, confirmationDialog } = this.state;
    let days = daysToSelect || [];
    if (!this.state.formData.length > 0) {
      slots.map(slot => {
        days.map((d, i) => {
          if (d.value === slot.day) {
            days[i].selected = true;
            days[i].slots = slot.slots;
            days[i].default = true;
          }
        });
      });
    }
    let times = [];

    slots.map(s => {
      s.slots.map(slot => {
        const index = times.findIndex(ele => {
          return ele.start === slot.start && ele.end === slot.end;
        });
        if (index < 0) {
          times.push({ start: slot.start, end: slot.end, from: slot.from, to: slot.to });
        }
      });
    });
    let currentTimeSlots = currentSlots
      ? currentSlots.slots
      : currentSlots !== undefined
        ? times
        : [];
    let formDataSlots = [];
    if (!!currentTimeSlots.length && !!formData.length) {
      formDataSlots = formData.filter(slot => {
        return (
          currentTimeSlots.findIndex(cts => {
            return (
              cts.start === slot.fromTime + slot.from &&
              cts.end === slot.toTime + slot.to
            );
          }) > -1
        );
      });
    } else {
      formDataSlots = formData;
    }

    if (dayToShow && formDataSlots.length > 0) {
      const selectedDaysFrom = formDataSlots[0].selectedDays;
      const index = selectedDaysFrom.indexOf(dayToShow);

      if (index < 0) {
        formDataSlots = [];
      }
    }

    currentTimeSlots = currentTimeSlots.map(currSlot => {
      let start = moment(currSlot.start, "hh:mm a");
      let end = moment(currSlot.end, "hh:mm a");

      if (currSlot.from != undefined) {
        start = moment(`${currSlot.start} ${currSlot.from}`, "hh:mm a");
        end = moment(`${currSlot.end} ${currSlot.to}`, "hh:mm a");
      }

      if (end.isBefore(start)) {
        currSlot.start = end.format('HH:mm');
        currSlot.end = start.format('HH:mm');
      }

      return currSlot;
    });

    currentTimeSlots = [...new Set(currentTimeSlots)];

    return (
      <div className="chef-right-col">
        <div className="schedule-head-col">
          <div className="header-step-col">
            <p className="located-text" style={style.headerText}>
              Define your schedule
            </p>
            <div className="cont-btn">
              <DinerButton />
            </div>
          </div>
        </div>
          <div className="schedule-col">
          <p style={style.subHeaderText}>This will be your weekly schedule for private engagements.</p>
          <Grid container data-test-id={'test-grid'}>
            <Grid item md={12}>
              <Grid container direction={"row"}>
                {currentTimeSlots.length > 0 && <div className="schedule-day-col">
                  {days.map((day, i) => (
                    <Button
                    data-test-id={"schdaybtn-id"}
                      key={i + day}
                      onClick={() => {
                        //this.selectDay(day);
                      }}
                      className="schedule-day-btn-step3"
                      variant={day.slots.length > 0 ? "contained" : "outlined"}
                      color="primary"
                      style={
                        day.slots.length > 0
                          ? i === 0
                            ? { ...style.dayButtonSelected, marginLeft: 0 }
                            : style.dayButtonSelected
                          : i === 0
                            ? { ...style.dayButton, marginLeft: 0 }
                            : style.dayButton
                      }
                    >
                      {day.name}
                    </Button>
                  ))}
                </div>}
                {currentTimeSlots.length > 0 &&
                  currentTimeSlots.map((slot, i) => (
                    <div className="date-btn" key={i + "slot"} data-test-id={'grid2'}>
                      <Button
                        data-test-id={"timeslot-id"}
                        fullWidth
                        variant="contained"
                        color="primary"
                        style={style.slotButton}
                      >
                        {slot.from != undefined && <p style={style.slotButtonText}>
                          {`${moment(
                          `${slot.start} ${slot.from}`,
                          "hh:mm a"
                        ).format("hh:mm a")} - ${moment(
                          `${slot.end} ${slot.to}`,
                          "hh:mm a"
                        ).format("hh:mm a")}`
                        }
                        </p>}
                        {slot.from === undefined && <p style={style.slotButtonText}>
                          {`${moment(
                            slot.start,
                            "hh:mm a"
                          ).format("hh:mm a")} - ${moment(
                            `${slot.end}`,
                            "hh:mm a"
                          ).format("hh:mm a")}`}</p>}
                      </Button>
                    </div>
                  ))}
                {formDataSlots &&
                  !!formDataSlots.length &&
                  formDataSlots.map((slot, idx) => (
                    <Grid item md={8} xs={12} key={idx + "myslot"}>
                      <Button
                      data-test-id={"timeslot-id"}
                        fullWidth
                        variant="contained"
                        color="primary"
                        style={style.slotButton}
                      >
                        <p style={style.slotButtonText}>{`${slot.fromTime}${
                          slot.from
                        } - ${slot.toTime}${slot.to}`}</p>
                      </Button>
                    </Grid>


                  ))}
                <Grid container direction="column">
                  {!!formDataSlots &&
                  !!formDataSlots.length &&
                  formDataSlots.map((slot, i) => (
                    <ScheduleButton
                      key={"schedule" + i}
                      startTime={slot.start}
                      endTime={slot.end}
                      onEditClick={() => this.updateWeekSlot(slot)}
                      onDelete={() => this.deleteWeekSchedule(slot)}
                    />
                  ))}
                </Grid>

              </Grid>
            </Grid>
            <Grid container style={style.contentContainer}>
              <Grid item md={12} sm={12} xs={12} style={style.buttonContainer}>
                {showCreateButton && <Button
                  className="mbl-100"
                  data-test-id={"createslot-id"}
                  onClick={() => this.setState({ openDrawer: true })}
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={style.scheduleCreateButton}
                >
                  <p style={style.buttonText}>+ Create Slot</p>
                </Button>}

                {currentTimeSlots.length > 0 && <Typography
                  variant="body1"
                  style={{ ...style.textFont, marginTop: 20, color: textGrey, fontSize: 14 }}
                >
                  Further edits to your schedule can be done from Schedule menu.
                </Typography>}
              </Grid>
            </Grid>
          </Grid>
        </div>

        <Grid item md={12} sm={12} style={{ textAlign: "right", marginTop: 20 }}>
            <Fab
              data-test-id={"schsubmit-id"}
              variant={"extended"}
              disabled={this.props.loading || showCreateButton}
              type="submit"
              id={"continue-submit"}
              style={
                this.props.loading || showCreateButton
                  ? style.disabledSubmitButton
                  : style.submitButton
              }
              onClick={() => {
                document.getElementById('continue-submit').disabled=true;
                this.props.nextScreen();
              }}
            >
              Continue
            </Fab>
          </Grid>

        <TimeSlot
          openDrawer={this.state.openDrawer}
          closeDrawer={() => this.toggelTimeSlotDrawer()}
          onCreate={formData => this.handelCreate(formData)}
          selectedDays={this.state.selectDays}
        />

        <ConfirmationDialog
          open={confirmationDialog}
          title={'Do you want close?'}
          positive={{
            title : 'yes',
            action: ()=>{
              this.setState({ confirmationDialog: false });
              this.setState({ openDrawer: false });
              window.location.reload();
            }
          }}
          negative={{
            title : 'No',
            action: ()=>{
              this.setState({ confirmationDialog: false });
            }
          }}
        />
      </div>
    );
  }
}

export default Schedule;


const ScheduleButton = props => {
  const checkInvalid = moment(new Date(props.startTime), "hh:mm").format("LT").toString().includes("Invalid");

  return (
      <Grid style={{paddingTop: 5}}>
        {!checkInvalid && <Paper
            variant="contained"
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: 0,
              paddingLeft: 15,
              background: primaryColor
            }}
        >
          <div>
            <p style={{color: "white"}}>
              {moment(new Date(props.startTime), "hh:mm").format("LT")} -
              {moment(new Date(props.endTime), "hh:mm").format("LT")}
            </p>
          </div>
          <div>
            <IconButton onClick={props.onEditClick}>
              <Edit style={{color: "white"}}/>
            </IconButton>
            <IconButton onClick={props.onDelete}>
              <Delete style={{color: "white"}}/>
            </IconButton>
          </div>
        </Paper>}
      </Grid>
  );
};

